import React,{useEffect} from 'react';
import {Navigate,useNavigate} from 'react-router-dom';
import {Helmet} from 'react-helmet';
import {enqueueSnackbar} from 'notistack';
import sendReqUtil from '../../utils/send-req-util';
import isOrganicUtil from '../../utils/is-organic-util';
import locales from '../../locales/locales';
import Navbar from '../navbar/navbar';
import Footer from '../footer/footer';
const Unsubber=({globalSettings})=>{
  const navigate=useNavigate();
  useEffect(()=>{
    if(!(globalSettings.token&&navigate&&isOrganicUtil())){
      return;
    }
    (async()=>{
      const res=await sendReqUtil('/marketing-optout');
      if(res.body&&res.status===200){
        enqueueSnackbar(
          locales.unsubberSuccess[globalSettings.lang]
        ,{variant:'success'});
      }
      else{
        enqueueSnackbar(
          locales.unsubberFailed[globalSettings.lang]
        ,{variant:'error'});
      }
      navigate(`/${globalSettings.lang}/`);
    })();
  },[navigate]);
  if(!globalSettings.token&&isOrganicUtil()){
    return <Navigate to={`/${globalSettings.lang}/login`} replace={false}/>;
  }
  return (
    <div className='min-h-screen flex flex-col bg-white'>
      <Helmet>
        <title>NekoTranslate - {locales.unsubberTitle[globalSettings.lang]}</title>
      </Helmet>
      <Navbar
        globalSettings={globalSettings}
      />
      <div className='flex-1 bg-purple-50 pt-16 flex items-center justify-center'>
        <div className='text-center px-4'>
          <h1 className='text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 py-4'>
            {locales.unsubberHeading[globalSettings.lang]}
          </h1>
        </div>
      </div>
      <Footer
        globalSettings={globalSettings}
      />
    </div>
  );
};
export default Unsubber;

